import { React, useState } from "react";
import AppLogo from "../../assets/Q Logo.jpg";
import {
  Drawer,
  List,
  Toolbar,
  Box,
  AppBar,
  Typography,
  Button,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: "rgba(122, 78, 55, 0.82) !important",
  backdropFilter: "blur(18px)",
  boxShadow: "0 18px 45px rgba(95, 58, 38, 0.15)",
  borderBottom: "1px solid rgba(255, 255, 255, 0.24)",
  zIndex: 1000,
  position: "sticky",
  top: 0,
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: "5.5rem",
  gap: "1rem",
  padding: "0 1.25rem",
  [theme.breakpoints.down("sm")]: {
    minHeight: "4.75rem",
    padding: "0 0.5rem 0 0.85rem",
  },
}));

const BrandButton = styled(Button)({
  borderRadius: "999px",
  padding: "0.45rem",
  minWidth: "unset",
});

const BrandMark = styled("img")({
  width: "3rem",
  height: "3rem",
  borderRadius: "999px",
  objectFit: "cover",
  boxShadow: "0 8px 18px rgba(58, 32, 18, 0.2)",
});

const BrandText = styled(Typography)(({ theme }) => ({
  flexGrow: 1,
  color: "#fff8f1",
  fontFamily: "'Fira Sans Extra Condensed', sans-serif",
  fontSize: "1.9rem",
  letterSpacing: "0.04em",
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.45rem",
  },
}));

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiPaper-root": {
    background:
      "linear-gradient(180deg, rgba(255, 248, 239, 0.98), rgba(244, 229, 211, 0.98))",
    width: "70vw",
    maxWidth: "21rem",
    textAlign: "center",
    justifyContent: "center",
    padding: "2rem 1.25rem",
    color: theme.palette.text.primary,
    boxShadow: "-16px 0 40px rgba(63, 43, 34, 0.16)",
  },
}));

const NavButton = styled(Button)(({ theme }) => ({
  borderRadius: "999px",
  padding: "0.45rem 1rem",
  color: "#fff8f1",
  letterSpacing: "0.05em",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.12)",
  },
}));

const StyledNavbarLink = styled(Link)({
  textDecoration: "none",
  color: "inherit",
  fontSize: "0.95rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.12em",
});

const DrawerItem = styled(Button)(({ theme }) => ({
  width: "100%",
  borderRadius: "1.25rem",
  margin: "0.35rem 0",
  padding: "0.8rem 1rem",
  color: theme.palette.text.primary,
  backgroundColor: "rgba(255, 255, 255, 0.45)",
}));

const StyledDrawerLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.text.primary,
  fontSize: "1rem",
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
}));

export default function ButtonAppBar() {
  const theme = useTheme();
  const collapse = useMediaQuery(theme.breakpoints.down("md"));
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event?.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };

  const drawer = (
    <>
      <Button onClick={toggleDrawer(true)} sx={{ minWidth: "unset" }}>
        <MenuIcon sx={{ color: "#fff8f1", fontSize: "2rem" }} />
      </Button>

      <StyledDrawer
        anchor="right"
        variant="temporary"
        open={isOpen}
        onClose={toggleDrawer(false)}
      >
        <Box role="presentation" onKeyDown={toggleDrawer(false)}>
          <List>
            <DrawerItem onClick={toggleDrawer(false)}>
              <StyledDrawerLink to="/">Main</StyledDrawerLink>
            </DrawerItem>
            <DrawerItem onClick={toggleDrawer(false)}>
              <StyledDrawerLink to="/about">About</StyledDrawerLink>
            </DrawerItem>
            <DrawerItem onClick={toggleDrawer(false)}>
              <StyledDrawerLink to="/archives">Archives</StyledDrawerLink>
            </DrawerItem>
            <DrawerItem onClick={toggleDrawer(false)}>
              <StyledDrawerLink to="/gallery">Gallery</StyledDrawerLink>
            </DrawerItem>
          </List>
        </Box>
      </StyledDrawer>
    </>
  );

  const navbar = (
    <>
      <NavButton>
        <StyledNavbarLink to="/">Main</StyledNavbarLink>
      </NavButton>
      <NavButton>
        <StyledNavbarLink to="/about">About</StyledNavbarLink>
      </NavButton>
      <NavButton>
        <StyledNavbarLink to="/archives">Archives</StyledNavbarLink>
      </NavButton>
      <NavButton>
        <StyledNavbarLink to="/gallery">Gallery</StyledNavbarLink>
      </NavButton>
    </>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <StyledAppBar>
        <StyledToolbar>
          <BrandButton
            onClick={() => {
              window.location.reload();
            }}
          >
            <BrandMark alt="" src={AppLogo} />
          </BrandButton>
          <BrandText>Daily Sarah</BrandText>
          {collapse ? drawer : navbar}
        </StyledToolbar>
      </StyledAppBar>
    </Box>
  );
}
